import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const ViewCartPageWrapper = styled.div(() => ({}));
export const MerchAccountSelect = styled.div(({ theme }) => ({
	minWidth: "320px",
	[theme.breakpoints.down("sm")]: {
		minWidth: "220px"
	}
}));

export const CartItemList = styled.div(({ theme }) => ({
	"& > * + *": {
		borderTop: theme.project.borders.presets.thinOutline
	}
}));

export const CartTotal = styled(Card)(({ theme }) => ({
	alignItems: "flex-end",
	backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50,
	borderRadius: "unset",
	color: theme.project.colors.primaryColors.main,
	display: "flex",
	flexDirection: "column",
	fontSize: 24,
	padding: "16px",
	[theme.breakpoints.down("md")]: {
		alignItems: "unset"
	},
	h6: {
		fontWeight: 500,
		fontSize: 24,
		margin: "0"
	},
	h5: {
		margin: "0",
		color: theme.project.colors.primaryColors.main
	},
	div: {
		display: "flex",
		alignItems: "center",
		gap: "24px"
	},
	p: {
		margin: "0",
		...theme.project.typography.subtitle.subtitle1
	}
}));

export const EstimatedTaxes = styled.div(() => ({
	fontSize: 14
}));
